/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Error_Message_MaxInputs */

const en_contact_error_message_max = /** @type {(inputs: Contact_Error_Message_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message must be less than 1000 characters`)
};

const lv_contact_error_message_max = /** @type {(inputs: Contact_Error_Message_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziņa nedrīkst pārsniegt 1000 rakstzīmes`)
};

/**
* | output |
* | --- |
* | "Message must be less than 1000 characters" |
*
* @param {Contact_Error_Message_MaxInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_error_message_max = /** @type {((inputs?: Contact_Error_Message_MaxInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Error_Message_MaxInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_error_message_max(inputs)
	return en_contact_error_message_max(inputs)
});